<!-- Breadcrumb -->
<div class="ui-g-12 flex-align-center">
  <div class="card-breadcrumb">

    <span class="breadcrumb" pTooltip="{{'campaign.campaignList' | translate}}" tooltipPosition="bottom">
      <i class="fa fa-home" [routerLink]="'/campaign-list-2'" ></i>
    </span>
    <i class="fa fa-chevron-right"></i>

    <span
      class="breadcrumb breadcrumb-menu"
      [ngStyle]="{'font-weight': actualStep === 'emission' ? 'bold' : 'normal'}"
      [ngClass]="{'unclickable': actualStep === 'emission'}"
      (click)="goToEmission()"
    >
      {{ 'campaign.emissionBreadcrumb' | translate }}
    </span>

    <span *ngIf="(stateAction === 4 || stateAction === 5 || stateAction === 6 || stateAction === 9) ">
      <i class="fa fa-chevron-right"></i>
      <span
        class="breadcrumb breadcrumb-menu"
        [ngStyle]="{'font-weight': actualStep === 'parameter' ? 'bold' : 'normal'}"
        [ngClass]="{'unclickable': actualStep === 'parameter'}"
        (click)="goToParameters()"
      >
        {{ 'campaign.parameterBreadcrumb' | translate }}
      </span>
    </span>

    <span *ngIf="(stateAction === 5 || stateAction === 6 || stateAction === 9) && actionTypeCode !== 'MSG'">
      <i class="fa fa-chevron-right"></i>
      <span
        [ngStyle]="{'font-weight': actualStep === 'fruition' ? 'bold' : 'normal'}"
        (click)="goToFruition()" class="breadcrumb breadcrumb-menu"
        [ngClass]="{'unclickable': actualStep === 'fruition'}"
      >
        {{ 'campaign.fruitionBreadcrumb' | translate }}
      </span>
    </span>

    <span *ngIf="stateAction === 6 || stateAction === 9 || ((stateAction === 4 || stateAction === 5)  && actionTypeCode === 'MSG')">
      <i class="fa fa-chevron-right"></i>
      <span
        [ngStyle]="{'font-weight': actualStep === 'layout' ? 'bold' : 'normal'}"
        (click)="goToLayout()" class="breadcrumb breadcrumb-menu"
        [ngClass]="{'unclickable': actualStep === 'layout'}"
      >
      {{ 'campaign.setLayout' | translate }}
      </span>
    </span>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-breadcrumb/campaign-breadcrumb.component.html